import { Box, Button, Container, Typography } from '@mui/material';

import { history } from '../../store/store';

export const ForbiddenPage = () => {
  const handleGoHome = () => {
    history.push('/');
  };

  return (
    <Container>
      <Box
        sx={{
          mt: 8,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
        }}
      >
        <Typography variant="h1" component="h1" gutterBottom>
          403
        </Typography>
        <Typography variant="h5" component="h2" gutterBottom>
          Access Forbidden
        </Typography>
        <Typography color="text.secondary" paragraph>
          You don't have permission to access this page.
        </Typography>
        <Button variant="contained" onClick={handleGoHome}>
          Go to Home
        </Button>
      </Box>
    </Container>
  );
};
